// Check for success parameter immediately (before hero JS cleans URL)
const urlParams = new URLSearchParams(window.location.search);
const newsletter = urlParams.get("newsletter");
const isFooterSuccess = newsletter === "success" && window.location.hash === "#footer";

document.addEventListener("DOMContentLoaded", function () {
  const messageDiv = document.getElementById("footer-signup-message");

  console.log("Footer JS loaded");
  console.log("Message div found:", messageDiv);
  console.log("Is footer success:", isFooterSuccess);

  if (isFooterSuccess && messageDiv) {
    console.log("Showing footer success message");
    showMessage("Thank you! We'll be in touch soon.", "success");
  }

  function showMessage(text, type) {
    console.log("showMessage called:", text, type);
    messageDiv.textContent = text;
    messageDiv.className = `footer-form-message footer-form-message--${type}`;
    messageDiv.style.display = "block";
    console.log("Message div after update:", messageDiv);
  }
});
